/* eslint-disable no-restricted-globals */
// @ts-nocheck
import React, { useEffect, useState } from "react";
import classNames from "classnames";
import { useLocation, useNavigate } from "react-router-dom";
import { ROUTES_PATHS } from "const";
import { LkPopup } from "./lkPopup";
import { useClickOutside } from "hooks";
import { useStores } from "hooks/useStores";

export const LkButton = () => {
  const [isUser, setIsUser] = useState(false);
  const [currentUser, setCurrentUser] = useState({});
  const [isOpenModal, setIsOpenModal] = useState(false);
  const { modalStore, api, cartStore } = useStores();
  
  const {getCartItems} = cartStore

  const buttonClasses = classNames({
    'lk-popup-outer': true,
    'lk-popup-outer--active': isOpenModal
  });

  const navigate = useNavigate();
  const location = useLocation()
  const logOut = () => {

    api.auth.postLogout()
    .then(() => {
      setIsUser(false)
      toggleModal();
      navigate(ROUTES_PATHS.MAIN);
      getCartItems();
    });
  };

  useEffect(() => {
      api.user.getCurrentUser()
        .then((res) => {
          setCurrentUser(res);
          setIsUser(true);
        })
        .catch((err) => {
          if (err.response.status === 401) {
            setIsUser(false);
          }
        });
  }, [location]);

  const toggleModal = () => {
    setIsOpenModal(!isOpenModal);
  }

  const closeModal = () => {
    setIsOpenModal(false);
  }
  
  const popupRef = useClickOutside(closeModal);

  const openLoginModal = () => {
    modalStore.open('login');
  }

  return (
    <>
    <div ref={popupRef}>
      <button onClick={toggleModal} id='callLkPopUp' className={buttonClasses}>
        <div className='lkbtn-inner' />
      </button>
      {
        isOpenModal 
        ? <LkPopup
          openLoginModal={openLoginModal}
          logOut={logOut}
          isUser={isUser}
          closeModal={closeModal}
          currentUser={currentUser}
        />
        :null
      }
      </div>
    </>
  );
}

export default LkButton